/** Flat key paths for CMS whitelist (nav, login, common, scan, profile, visitor). */
export function flattenLocaleSections(
  tree: Record<string, unknown>,
  sections: string[] = ["nav", "login", "common", "scan", "profile", "visitor"],
): Record<string, string> {
  const out: Record<string, string> = {};
  for (const section of sections) {
    const node = tree[section];
    if (!node || typeof node !== "object") continue;
    walk(node as Record<string, unknown>, section, out);
  }
  return out;
}

function walk(node: Record<string, unknown>, prefix: string, out: Record<string, string>) {
  for (const [k, v] of Object.entries(node)) {
    const path = `${prefix}.${k}`;
    if (typeof v === "string") out[path] = v;
    else if (v && typeof v === "object" && !Array.isArray(v)) {
      walk(v as Record<string, unknown>, path, out);
    }
  }
}
